import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterAppBusyStateComponentDef } from '@df/ui/display/busy-state/router-app-busy-state.component.def';

@Component({
    selector: 'router-app-busy-state',
    template: `
        <ng-template #defaultTpl>
            <i class="fs-10 icon-loading" aria-label="Loading"></i>
        </ng-template>
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouterAppBusyStateComponent extends RouterAppBusyStateComponentDef {}
